import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import { Options } from "@angular-slider/ngx-slider";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { CommonService } from "../services/common.service";
import { ActivatedRoute } from "@angular/router";
import { DataService } from "../dataService/data.service";
import { ToastrService } from "ngx-toastr";
import { GlobalVariable } from "../app.component";

@Component({
  selector: "app-review-improvement",
  templateUrl: "./review-improvement.component.html",
  styleUrls: ["./review-improvement.component.scss"],
})
export class ReviewImprovementComponent implements OnInit {
  @ViewChild("thankyoumodal", { static: true }) thankyoumodal: ElementRef;
  private BASE_URL = GlobalVariable;

  // Set standard default values for payload
  DEFAULT_FEEDBACK_SCALE = {
    TWO_POINT_SCALE: "TWO_POINT_SCALE",
    FIVE_POINT_SCALE: "FIVE_POINT_SCALE",
    TEN_POINT_SCALE: "TEN_POINT_SCALE",

    TWO_POINT: {
      FORMAL: {
        POSITIVE: "thumbs_up",
        NEGATIVE: "thumbs_down",
      },
      FRIENDLY: {
        NEGATIVE: "1",
        POSITIVE: "5",
      },
    },
    FIVE_POINT: {
      FORMAL: {
        ONE: "1",
        TWO: "2",
        THREE: "3",
        FOUR: "4",
        FIVE: "5",
      },
      FRIENDLY: {
        ONE: "1",
        TWO: "2",
        THREE: "3",
        FOUR: "4",
        FIVE: "5",
      },
    },
    SLUG_TYPE: {
      FORMAL: "Formal",
      FRIENDLY: "Friendly",
    },
  };

  twoPointFormal = [
    {
      icon: "assets/images/thumbs-up.svg",
      rating: this.DEFAULT_FEEDBACK_SCALE.TWO_POINT.FORMAL.POSITIVE,
      scale_type: this.DEFAULT_FEEDBACK_SCALE.TWO_POINT_SCALE,
      rating_type: "POSITIVE",
      slug_type: this.DEFAULT_FEEDBACK_SCALE.SLUG_TYPE.FORMAL,
    },
    {
      icon: "assets/images/thumbs-down.svg",
      rating: this.DEFAULT_FEEDBACK_SCALE.TWO_POINT.FORMAL.NEGATIVE,
      scale_type: this.DEFAULT_FEEDBACK_SCALE.TWO_POINT_SCALE,
      rating_type: "NEGATIVE",
      slug_type: this.DEFAULT_FEEDBACK_SCALE.SLUG_TYPE.FORMAL,
    },
  ];
  twoPointFriendly = [
    {
      icon: "assets/gifs/1.png",
      rating: this.DEFAULT_FEEDBACK_SCALE.TWO_POINT.FRIENDLY.POSITIVE,
      scale_type: this.DEFAULT_FEEDBACK_SCALE.TWO_POINT_SCALE,
      slug_type: this.DEFAULT_FEEDBACK_SCALE.SLUG_TYPE.FRIENDLY,
    },
    {
      icon: "assets/gifs/2.png",
      rating: this.DEFAULT_FEEDBACK_SCALE.TWO_POINT.FRIENDLY.NEGATIVE,
      scale_type: this.DEFAULT_FEEDBACK_SCALE.TWO_POINT_SCALE,
      slug_type: this.DEFAULT_FEEDBACK_SCALE.SLUG_TYPE.FRIENDLY,
    },
  ];
  fivePointFormal = [
    {
      label: "1",
      rating: this.DEFAULT_FEEDBACK_SCALE.FIVE_POINT.FORMAL.ONE,
      scale_type: this.DEFAULT_FEEDBACK_SCALE.FIVE_POINT_SCALE,
      slug_type: this.DEFAULT_FEEDBACK_SCALE.SLUG_TYPE.FORMAL,
    },
    {
      label: "2",
      rating: this.DEFAULT_FEEDBACK_SCALE.FIVE_POINT.FORMAL.TWO,
      scale_type: this.DEFAULT_FEEDBACK_SCALE.FIVE_POINT_SCALE,
      slug_type: this.DEFAULT_FEEDBACK_SCALE.SLUG_TYPE.FORMAL,
    },
    {
      label: "3",
      rating: this.DEFAULT_FEEDBACK_SCALE.FIVE_POINT.FORMAL.THREE,
      scale_type: this.DEFAULT_FEEDBACK_SCALE.FIVE_POINT_SCALE,
      slug_type: this.DEFAULT_FEEDBACK_SCALE.SLUG_TYPE.FORMAL,
    },
    {
      label: "4",
      rating: this.DEFAULT_FEEDBACK_SCALE.FIVE_POINT.FORMAL.FOUR,
      scale_type: this.DEFAULT_FEEDBACK_SCALE.FIVE_POINT_SCALE,
      slug_type: this.DEFAULT_FEEDBACK_SCALE.SLUG_TYPE.FORMAL,
    },
    {
      label: "5",
      rating: this.DEFAULT_FEEDBACK_SCALE.FIVE_POINT.FORMAL.FIVE,
      scale_type: this.DEFAULT_FEEDBACK_SCALE.FIVE_POINT_SCALE,
      slug_type: this.DEFAULT_FEEDBACK_SCALE.SLUG_TYPE.FORMAL,
    },
  ];
  fivePointFriendly = [
    {
      icon: "assets/images/social/1-verypoor.svg",
      rating: this.DEFAULT_FEEDBACK_SCALE.FIVE_POINT.FORMAL.ONE,
      scale_type: this.DEFAULT_FEEDBACK_SCALE.FIVE_POINT_SCALE,
      slug_type: this.DEFAULT_FEEDBACK_SCALE.SLUG_TYPE.FRIENDLY,
    },
    {
      icon: "assets/images/social/2-poor.svg",
      rating: this.DEFAULT_FEEDBACK_SCALE.FIVE_POINT.FORMAL.TWO,
      scale_type: this.DEFAULT_FEEDBACK_SCALE.FIVE_POINT_SCALE,
      slug_type: this.DEFAULT_FEEDBACK_SCALE.SLUG_TYPE.FRIENDLY,
    },
    {
      icon: "assets/images/social/3-average.svg",
      rating: this.DEFAULT_FEEDBACK_SCALE.FIVE_POINT.FORMAL.THREE,
      scale_type: this.DEFAULT_FEEDBACK_SCALE.FIVE_POINT_SCALE,
      slug_type: this.DEFAULT_FEEDBACK_SCALE.SLUG_TYPE.FRIENDLY,
    },
    {
      icon: "assets/images/social/4-good.svg",
      rating: this.DEFAULT_FEEDBACK_SCALE.FIVE_POINT.FORMAL.FOUR,
      scale_type: this.DEFAULT_FEEDBACK_SCALE.FIVE_POINT_SCALE,
      slug_type: this.DEFAULT_FEEDBACK_SCALE.SLUG_TYPE.FRIENDLY,
    },
    {
      icon: "assets/images/social/5-excellent.svg",
      rating: this.DEFAULT_FEEDBACK_SCALE.FIVE_POINT.FORMAL.FIVE,
      scale_type: this.DEFAULT_FEEDBACK_SCALE.FIVE_POINT_SCALE,
      slug_type: this.DEFAULT_FEEDBACK_SCALE.SLUG_TYPE.FRIENDLY,
    },
  ];
  // Set default value for ten point scale to 8
  tenPointValue = 8;
  options: Options = {
    showTicksValues: false,
    stepsArray: [
      { value: 1 },
      { value: 2, legend: "Very Disatisfield" },
      { value: 3 },
      { value: 4, legend: "Disatisfield" },
      { value: 5 },
      { value: 6, legend: "Average" },
      { value: 7 },
      { value: 8, legend: "Good" },
      { value: 9 },
      { value: 10, legend: "Excelent" },
    ],
    showTicks: true,
  };
  reviewsPlatform: {} = {};
  loading: boolean;
  redirectLink: string = "";
  businessName: string = "";
  logoUrl: string = "";
  customerName: string = "";
  // Friendly, Formal
  consumerChoice: string = "";
  // 2, 5, 10 point value
  feedbackScale: string;
  // user set negative rating
  negativeRating: number;
  // review slug value
  slugValue: any;
  // feedback rating payload
  payload: {
    thumbs: any;
    faces: any;
    formal_rating: any;
    review_scale_type: any;
  };
  // selected slug rating value
  selectedSlugRating = null;
  // converted rating value for feedback star
  starRating: number;
  // to check selected rating is negative
  isNegativeRating: boolean = false;
  feedbackText: string = "";
  // 1, 2 click flow
  reviewClickSteps: string;
  // validate feedback payload
  isInvalidFeedback: boolean;
  // to disable submit button
  submitFeedbackClicked: boolean;
  // To show/hide thankyou modal before redirecting external platform page
  reviewGateway: boolean;
  // to redirect to external review page
  feedbackOnlyFlow: boolean;
  // welcome message on main screen
  welcomeMessage: string = "";
  // thank you message in modal
  thankYouMessage: string = "";
  slugHasFeedback: boolean = false;
  feedbackAlreadyGiven: string = "Thank you for providing feedback.";
  private _isShowThankYouScreen: boolean;
  showFeedbackOption: boolean;
  showPoweredBy: boolean = false;

  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private modalService: NgbModal,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private httpService: DataService,
    private toastrService: ToastrService
  ) {}

  ngOnInit(): void {
    this.loading = true;
    // get slugvalue
    this.route.params.forEach((val) => {
      this.slugValue = val["id"];
    });
    // common api response for review slug
    this.commonService.commonData.subscribe((data: any) => {
      if (data != null) {
        this.businessName = data["business_name"];
        this.showPoweredBy = data["show_powered_by_logo"];
        this.logoUrl = data["business_logo"];
        this.customerName = data["contact_name"];
        this.consumerChoice = data["consumer_link"];
        this.feedbackScale = data["feedback_scale"];
        this.negativeRating = data["negative_rating"];
        this.reviewClickSteps = data["review_click_steps"];
        this.reviewGateway = data["review_gateway"];
        // if enable_external_review is true then capture only zceppa reviews.
        this.feedbackOnlyFlow = data["enable_external_review"];
        this.welcomeMessage = data["consumer_welcome_message"];
        this.thankYouMessage = data["consumer_thank_you_message"];
        this.slugHasFeedback = data["slug_has_feedback"];
        // this.isShowThankYouScreen  = this.slugHasFeedback;
        this.feedbackOnlyFlow && this.showThankYouScreen();
        this.loading = false;

        if (
          data["google"] !== undefined &&
          data["google"].google_link !== null
        ) {
          this.reviewsPlatform["google"] = data["google"].google_link;
        }
        if (
          data["facebook"] !== undefined &&
          data["facebook"].fb_link !== null
        ) {
          this.reviewsPlatform["facebook"] = data["facebook"].fb_link;
        }
        if (data["custom"] !== undefined) {
          data["custom"].forEach((val: any, key: any) => {
            if (val.url !== null) {
            }
            if (val.type === "zomato") {
              this.reviewsPlatform["zomato"] = val.url;
            }
            if (val.type === "trip_advisor") {
              this.reviewsPlatform["trip_advisor"] = val.url;
            }
            if (val.type === "practo") {
              this.reviewsPlatform["practo"] = val.url;
            }
            if (val.type === "just_dail") {
              this.reviewsPlatform["just_dail"] = val.url;
            }
            if (val.type === "amazon") {
              this.reviewsPlatform["amazon"] = val.url;
            }
          });
        }
        // set autoredirect link
        const auto_redirect = this.storage.get("auto_redirect");
        if (auto_redirect != "null") {
          this.redirectLink = this.reviewsPlatform[auto_redirect];
        }
      }
    });
    this.commonService.getData();

    // select slug rating for ten point scale on page load coz rating value is pre selected
    if (this.feedbackScale == "10" && this.consumerChoice == "Formal") {
      this.onSlugSelect({
        scale_type: this.DEFAULT_FEEDBACK_SCALE.TEN_POINT_SCALE,
        ten_point_scale_on_load: true,
      });
    }
  }
  /**
   * To set payload based on user selection
   * @param slug selected slug rating and type
   */
  onSlugSelect(slug: {
    scale_type?: string;
    rating?: any;
    slug_type?: string;
    ten_point_scale_on_load?: boolean;
  }) {
    let thumbs = null;
    let faces = null;
    let formal_rating = null;

    // set rating value to formal_rating key for ten point scale
    if (slug?.scale_type == this.DEFAULT_FEEDBACK_SCALE.TEN_POINT_SCALE) {
      formal_rating = this.tenPointValue;
      this.selectedSlugRating = formal_rating;
    } else {
      // set rating value to thumbs/faces key for two point scale - formal, friendly
      this.selectedSlugRating = slug?.rating;
      if (slug?.scale_type == this.DEFAULT_FEEDBACK_SCALE.TWO_POINT_SCALE) {
        if (slug?.slug_type == this.DEFAULT_FEEDBACK_SCALE.SLUG_TYPE.FORMAL) {
          thumbs = this.selectedSlugRating;
        } else {
          faces = this.selectedSlugRating;
        }
      }
      // set rating value to formal_rating/faces key for five point scale - formal, friendly
      if (slug?.scale_type == this.DEFAULT_FEEDBACK_SCALE.FIVE_POINT_SCALE) {
        if (slug?.slug_type == this.DEFAULT_FEEDBACK_SCALE.SLUG_TYPE.FORMAL) {
          formal_rating = this.selectedSlugRating;
        } else {
          faces = this.selectedSlugRating;
        }
      }
    }

    const payload = {
      slug: this.slugValue,
      thumbs: thumbs,
      faces: faces,
      formal_rating: formal_rating?.toString() || null,
      review_scale_type: slug?.scale_type,
    };
    this.payload = payload;

    // Set star rating and validate negative rating on slug selection
    this.setStarRating(slug?.ten_point_scale_on_load || false);
  }

  /**
   * On submitting feedback
   * Function called on submit click
   * @returns
   */
  async onSubmitFeedBack() {
    // Validate slug rating
    if (!this.payload || !Object.keys(this.payload).length) {
      this.toastrService.error("Please select a rating");
      return;
    }

    this.isInvalidFeedback = false;
    // Validate mandatory field
    if (
      (this.isNegativeRating || this.feedbackOnlyFlow) &&
      !this.feedbackText?.trim()
    ) {
      this.isInvalidFeedback = true;
      this.toastrService.error("Please Enter Feedback");
      return;
    }

    try {
      this.submitFeedbackClicked = true;
      // update feedback rating for the slug
      let updateFeedbackRating = await this.updateFeedbackRating();
      // update feedback text and star rating
      let updateFeedbackToZceppa = true;
      if (this.feedbackText?.trim()) {
        updateFeedbackToZceppa = await this.updateFeedbackToZceppa();
      }
      if (updateFeedbackRating && updateFeedbackToZceppa) {
        this.submitFeedbackClicked = false;
        // To redirect external platform based on condition
        this.redirectToExternalPlatform();
      }
    } catch (error) {
      this.submitFeedbackClicked = false;
      console.error(error);
    }
  }

  /**
   * To submit selected feedback rating
   * @returns Promise boolean
   */
  updateFeedbackRating(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.httpService
        .putRequest({
          customApiUrl: this.BASE_URL.REVIEW_RATING_API,
          data: this.payload,
        })
        .subscribe(
          (res) => {},
          (error) => {
            reject(true);
            this.toastrService.error(error.error.message);
          },
          () => {
            resolve(true);
          }
        );
    });
  }

  /**
   * To update feedback text and star rating
   * @returns Promise boolean
   */
  updateFeedbackToZceppa(): Promise<boolean> {
    const payload = {
      slug: this.slugValue,
      feedback_text: this.feedbackText,
      feedback_star: this.starRating,
    };
    return new Promise((resolve, reject) => {
      this.httpService
        .postRequest({
          customApiUrl: this.BASE_URL.SMS_SLUG_REQUEST_URL,
          data: payload,
        })
        .subscribe(
          (res) => {
            if (res.code == 202) {
              reject(true);
              this.toastrService.error(res.data["message"]);
            } else {
              resolve(true);
            }
          },
          (error) => {
            reject(true);
            this.toastrService.error(error.error.message);
          },
          () => {
            resolve(true);
          }
        );
    });
  }

  /**
   * To set star rating based on slug selection
   * To verify selected value as positive/negative
   */
  setStarRating(ten_point_scale_on_load: boolean = false) {
    let isNegativeRating = false;

    // Check whether 2 point scale formal is selected
    if (this.payload?.thumbs == null) {
      // Convert selected value between 1 to 5 for star rating and negative limit check
      if (
        this.payload?.review_scale_type ==
        this.DEFAULT_FEEDBACK_SCALE.TEN_POINT_SCALE
      ) {
        // convert into 1 to 5 using division by 2
        let ratingConversion: number = Math.round(
          Number(this.selectedSlugRating) / 2
        );
        this.starRating = ratingConversion;
      } else {
        // change string value to number
        this.starRating = Number(this.selectedSlugRating);
      }
    } else {
      // set value for 2 point formal rating
      if (
        this.selectedSlugRating ==
        this.DEFAULT_FEEDBACK_SCALE.TWO_POINT.FORMAL.NEGATIVE
      ) {
        // for thumbs down set value based on negative rating
        this.starRating = this.negativeRating;
      } else {
        // for thumbs up set max value
        this.starRating = 5;
      }
    }

    // check whether selected rating is positive/negative to show/redirect to external platform
    if (this.negativeRating >= this.starRating) {
      isNegativeRating = true;
    }
    this.isNegativeRating = isNegativeRating;

    this.showFeedbackOption = false;
    // if positive rating and feedback only is off and (2 or 5) point scale is selected then redirect to external platform page
    if (
      !this.feedbackOnlyFlow &&
      !this.isNegativeRating &&
      !ten_point_scale_on_load &&
      this.selectedSlugRating !== this.DEFAULT_FEEDBACK_SCALE.TEN_POINT_SCALE
    ) {
      // For WhatsApp + positive: redirect synchronously here (before async API calls)
      // so the gesture context is preserved on Android WebView
      if (this.isWhatsAppBrowser()) {
        this.openInExternalBrowser();
        // fire API calls in background without awaiting
        this.onSubmitFeedBack();
      } else {
        this.onSubmitFeedBack();
      }
    } else {
      this.showFeedbackOption = true;
    }
  }

  private openInExternalBrowser() {
    const googleUrl = this.reviewsPlatform["google"] || "";
    if (!googleUrl) return;
    const ua = navigator.userAgent || "";
    const isAndroid = /Android/i.test(ua);
    const stripped = googleUrl.replace(/^https?:\/\//, "");
    const fallback = encodeURIComponent(googleUrl);
    if (isAndroid) {
      window.location.href = `intent://${stripped}#Intent;scheme=https;package=com.android.chrome;S.browser_fallback_url=${fallback};end`;
    } else {
      window.location.href = `x-safari-https://${stripped}`;
    }
  }

  /**
   * Redirect to external platform page based on review gateway and negative rating
   * @returns
   */
  redirectToExternalPlatform() {
    if (this.isNegativeRating && this.reviewGateway) {
      this.openModal();
      return;
    }
    // redirect to external page when enabled
    if (this.feedbackOnlyFlow) {
      this.commonService.getCommonData(this.slugValue);
      // show thank you page when external review and review gateway is OFF.
      this.showThankYouScreen(!this.isNegativeRating);
    } else {
      // Redirect to external platform page when feedback only is OFF.
      // (WhatsApp positive redirect is handled synchronously in setStarRating to preserve gesture context)
      this.externalPlatformPage();
    }
  }

  private isWhatsAppBrowser(): boolean {
    const ua = navigator.userAgent || "";
    return (
      /WhatsApp/i.test(ua) ||
      /\[WAiOS\//i.test(ua) ||
      /\[WABIZ\//i.test(ua) ||
      /WA4A\//i.test(ua)
    );
  }


  /**
   * To redirect to external review page
   */
  externalPlatformPage() {
    this.commonService.openCustomerReviewPage("YES", this.isNegativeRating);
  }

  /**
   * Setter boolean value for _isShowThankYouScreen
   */
  set isShowThankYouScreen(showThankYouScreen: boolean) {
    this._isShowThankYouScreen = showThankYouScreen;
  }

  /**
   * Getter boolean value for _isShowThankYouScreen
   */
  get isShowThankYouScreen() {
    return this._isShowThankYouScreen;
  }

  /**
   * To show thank you screen after submitting feedback
   * show thank you screen when feedbackOnlyFlow is ON
   * @alias feedbackOnlyFlow as enable_external_review
   * @param showThankyouMessage @default boolean false
   * @returns
   */
  showThankYouScreen(showThankyouMessage: boolean = false) {
    // when this.feedbackOnlyFlow true then don't allow to external review page
    if (!showThankyouMessage) {
      this.isShowThankYouScreen = this.feedbackOnlyFlow && this.slugHasFeedback;
      return;
    }
    // Show thank you page when user click OK in thank you modal
    this.isShowThankYouScreen = showThankyouMessage;
  }

  /**
   * opens thank you modal
   */
  openModal() {
    this.modalService.open(this.thankyoumodal, {
      size: "sm",
      windowClass: "modalfeedback",
      centered: true,
      backdrop: "static",
    });
  }
}
